$ = require('jquery');
require('jquery-validation');

$.ready(() => {
  $.validator.addMethod("phoneUS", function(phone_number, element) {
      phone_number = phone_number.replace(/\s+/g, ""); 
      return (this.optional(element) || phone_number.length > 9 &&
          phone_number.match(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/));
  }, "Please specify a valid phone number");
})


function slideUp(el){
    if(window.is_bad_IE){
        el.hide();
    }else{
        el.slideUp();
    }
}

function slideDown(el){
    if(window.is_bad_IE){
        el.show();
    }else{
        el.slideDown();
    }
}

export function enable_boardroom_form(el){
    var new_booking_checked = function(){
        return $('form.boardroom input[name=appointment_type]:checked').val() == 'new';
    }

    var reschedule_checked = function(){
        return $('form.boardroom input[name=appointment_type]:checked').val() == 'reschedule';
    }

    var cancel_checked = function(){
        return $('form.boardroom input[name=appointment_type]:checked').val() == 'cancel';
    }

    var toggle_form_view = function(){
        var appt_type = $('form.boardroom input[name=appointment_type]:checked').val();
        if (appt_type === 'new') {
            $('fieldset.time li.original_appointment_date').hide();
        }else{
            $('fieldset.time li.original_appointment_date').show();
        }

        if (appt_type === 'cancel') {
            $('fieldset.time li.new_appointment_date').hide();
            $('fieldset.time li.duration').hide();
            $('fieldset.time li.names_of_attendees').hide();
        } else {
            $('fieldset.time li.new_appointment_date').show();
            $('fieldset.time li.duration').show();
            $('fieldset.time li.names_of_attendees').show();
        }
    }

    $('form.boardroom input[name=appointment_type]:radio').click(toggle_form_view);
    toggle_form_view();
};

export function enable_discovery_form(el){
    var new_appt_checked = function(){
        return $('form.discovery input[name=appointment_type]:checked').val() == 'new';
    };

    var reschedule_checked = function(){
        return $('form.discovery input[name=appointment_type]:checked').val() == 'reschedule';
    };

    var cancel_checked = function(){
        return $('form.discovery input[name=appointment_type]:checked').val() == 'cancel';
    };

    var discovery_checked = function(){
        return $('form.discovery input[name=booking_type]:checked').val() == 'discovery';
    };

    var mediation_checked = function(){
        return $('form.discovery input[name=booking_type]:checked').val() == 'mediation';
    };

    var videoconference_checked = function(){
        return $('form.discovery input[name=location]:checked').val() == 'Videoconference';
    };

    var toggle_form_view = function(){
        var type = $('form.discovery input[name=booking_type]:checked').val();
        var appt_type = $('form.discovery input[name=appointment_type]:checked').val();

        if(appt_type == 'new'){
            if(type != 'discovery'){
                $('fieldset.new-discovery').hide();
            }else{
                $('fieldset.new-discovery').show();
            }

            if(type != 'mediation'){
                $('fieldset.new-mediation').hide();
            }else{
                $('fieldset.new-mediation').show();
            }
        }else{
            // Show nothing if we're rebooking/cancelling
            $('fieldset.new-discovery').hide();
            $('fieldset.new-mediation').hide();
        }

        // Show this part for rescheduling too
        if(appt_type != 'cancel' && type == 'discovery'){
            $('fieldset.discovery').show();
        }else{
            $('fieldset.discovery').hide();
            $('li.witnesses').hide();
            $('li.registry_number').hide();
        }

        // Show witnesses and registry number for new discovery only
        if(appt_type == 'new' && type == 'discovery'){
            $('li.witnesses').show();
            $('li.registry_number').show();
        }else{
            $('li.witnesses').hide();
            $('li.registry_number').hide();
        }


        if(appt_type != 'reschedule' && appt_type != 'cancel'){
            $('fieldset.time li.original_appointment_date').hide();
        }else{
            $('fieldset.time li.original_appointment_date').show();
        }

        if(appt_type == 'cancel'){
            $('fieldset.time li.new_appointment_date').hide();
            $('fieldset.time li.duration').hide();
            $('input[type=submit]', el).val('Submit Cancellation');
        }else{
            $('fieldset.time li.new_appointment_date').show();
            $('fieldset.time li.duration').show();
            $('input[type=submit]', el).val('Request Appointment');
        }

        if(type == 'discovery'){
            $('li.location').show();


            if(videoconference_checked()) {
              $('li.booking-lawyer-email').show()
              $('li.opposing-counsel-email').show()
              $('li.opposing-counsel-assistant').show()
              $('li.opposing-counsel-assistant-email').show()
            } else {
              $('li.booking-lawyer-email').hide()
              $('li.opposing-counsel-email').hide()
              $('li.opposing-counsel-assistant').hide()
              $('li.opposing-counsel-assistant-email').hide()
            }

        }else{
            $('li.location').hide();
        }
    };


    $('form.discovery input[name=booking_type]:radio').click(toggle_form_view);
    $('form.discovery input[name=appointment_type]:radio').click(toggle_form_view);
    $('form.discovery input[name=location]:radio').click(toggle_form_view);
    toggle_form_view();

    var new_discovery = function(){ return discovery_checked() && new_appt_checked(); };
    var new_mediation = function(){ return mediation_checked() && new_appt_checked(); };


    $(el).validate({
        handleSuccess: function(){
            alert("Success!\n\n Everything went better than expected.");

        },
        rules: {

            // Validation rules for each field, if necessary.

            original_appointment_date: {
                required: { 
                    depends: function(){
                        return reschedule_checked() || cancel_checked();
                    }
                }
            },

        date: {
            required: {
                depends: function(){
                    return reschedule_checked() || new_appt_checked();
                }
            }
        },

        // Discovery-only fields
        duration: { required: { depends: new_discovery }},
        location: { required: { depends: new_discovery }},
        booking_lawyer_first_name: { required: { depends: new_discovery }},
        booking_lawyer_last_name: { required: { depends: new_discovery }},
        booking_lawyer_acting_for: { required: { depends: new_discovery }},
        opposing_counsel_first_name: { required: { depends: new_discovery }},
        opposing_counsel_last_name: { required: { depends: new_discovery }},
        opposing_counsel_acting_for: { required: { depends: new_discovery }},
        additional_counsel: { required: false},
        icbc_claim_number: { required: false},
        witnesses: { required: false},
        registry_number: { required: false},

        // Mediation-only fields

        mediator_name: { required: { depends: new_mediation }},
        plaintiffs_counsel: { required: { depends: new_mediation }},
        defense_counsel: { required: { depends: new_mediation }},
        num_attendees: { required: { depends: new_mediation }},
        num_rooms: { required: { depends: new_mediation }},

        // Other rules
        contact_name: {
            required:true
        },

        contact_phone: {
            required: true,
            phoneUS: true
        }
        }
    });
};

export function enable_chambers_form(el){
    var pat_checked = function(){
        return !!$('form.order_chambers_transcript input[name=order_proceedings_at_trial]:checked').val();
    };

    var excerpt_checked = function(){
        return !!$('form.order_chambers_transcript input[name=order_excerpt_of_proceedings_at_trial]:checked').val();
    };

    var orj_checked = function(){
        return !!$('form.order_chambers_transcript input[name=order_oral_reasons_for_judgement]:checked').val();
    };

    var ruling_checked = function(){
        return !!$('form.order_chambers_transcript input[name=order_ruling]:checked').val();
    };

    var toggle_form_visibility = function(){
        if(pat_checked()){
            $('fieldset.proceedings-at-trial').show();
        }else{
            $('fieldset.proceedings-at-trial').hide();
        }

        if(excerpt_checked()){
            $('fieldset.excerpt-of-proceedings').show();
        }else{
            $('fieldset.excerpt-of-proceedings').hide();
        }

        if(orj_checked()){
            $('fieldset.oral-reasons').show();
        }else{
            $('fieldset.oral-reasons').hide();
        }

        if(ruling_checked()){
            $('fieldset.ruling').show();
        }else{
            $('fieldset.ruling').hide();
        }
    };

    toggle_form_visibility();

    $('form.order_chambers_transcript input[name=order_proceedings_at_trial]').click(toggle_form_visibility).change(toggle_form_visibility);
    $('form.order_chambers_transcript input[name=order_excerpt_of_proceedings_at_trial]').click(toggle_form_visibility).change(toggle_form_visibility);
    $('form.order_chambers_transcript input[name=order_oral_reasons_for_judgement]').click(toggle_form_visibility).change(toggle_form_visibility);
    $('form.order_chambers_transcript input[name=order_ruling]').click(toggle_form_visibility).change(toggle_form_visibility);

    $(el).validate({
        rules: {

            // Validation rules for each field, if necessary.

            // Common Fields
            ordering_lawyer_first_name: { required: true },
        ordering_lawyer_last_name: { required: true },
        law_firm: { required: true },
        style_of_cause: { required: true },
        style_of_cause_file: { required: false},
        court_registry: { required:true },
        registry: { required: true },
        judge_first_name: { required: false },
        judge_last_name: { required: true },
        dates_of_proceeding: {required: true },

        // PAT

        pat_include_submissions: {
            required: { depends: pat_checked }
        },

        pat_transcript_delivery_time: {
            required: { depends: pat_checked }
        },

        // Excerpt

        excerpt_description: {
            required: { depends: excerpt_checked }
        },

        excerpt_transcript_delivery_time: {
            required: { depends: excerpt_checked }
        },

        // orj

        orj_include_ruling_on_costs: {
            required: { depends: orj_checked }
        },

        orj_include_submissions: {
            required: { depends: orj_checked }
        },

        orj_transcript_delivery_time: {
            required: { depends: orj_checked }
        },

        // Ruling
        ruling_include_submissions: {
            required: { depends: ruling_checked }
        },

        ruling_transcript_delivery_time: {
            required: { depends: ruling_checked }
        },

        // Other rules
        contact_name: {
            required:true
        },

        contact_phone: {
            required: true,
            phoneUS: true
        }
        }
    });


};

export function enable_appeal_books_form(el){
    var transcript_book_checked = function(){
        return !!$('form.order_appeal_books input[name=order_transcript_book]:checked').val();
    };

    var toggle_form_visibility = function(){
        if(transcript_book_checked()){
            slideDown($('fieldset.transcript-book'));
        }else{
            slideUp($('fieldset.transcript-book'));
        }
    }

    toggle_form_visibility();

    $('form.order_appeal_books input[name=order_transcript_book]').click(toggle_form_visibility).change(toggle_form_visibility);

    $(el).validate({
        rules: {

            // Validation rules for each field, if necessary.

            // Common Fields
            style_of_cause: { required: true },
        date_notice_of_appeal_filed: { required: true },
        notice_of_appeal: {required: false },
        court_of_appeal_file_no: { required: true },
        lower_court_file_no: { required: true },
        judge: { required: true },
        full_dates_of_trial: { required: true },
        appellants_counsel_first_name: { required: true },
        appellants_counsel_last_name: { required: true },
        appellants_counsel_law_firm: { required: true },
        respondents_counsel_first_name: { required: true },
        respondents_counsel_last_name: { required: true },
        respondents_counsel_law_firm: { required: true },

        //transcript_book
        //appeal_record
        //appeal_book

        include_opening_submissions: {
            required: { depends: transcript_book_checked }
        },
        include_trial_submissions: {
            required: { depends: transcript_book_checked }
        },

        include_closing_arguments: {
            required: { depends: transcript_book_checked }
        },

        // Other rules
        contact_name: {
            required:true
        },

        contact_phone: {
            required: true,
            phoneUS: true
        }
        }
    });


};

export function enable_icbc_form(el, callback){


    // Checking functions
    var hard_copy_checked = function(){
        return !!$('form.upload_form input[name=hard_copy_required]:checked').val();
    };

    var send_with_hard_copy_checked = function(){
        return !!$('form.upload_form input[name=send_with_hard_copy]:checked').val();
    };

    var send_with_electronic_checked = function(){
        return !!$('form.upload_form input[name=send_with_electronic]:checked').val();
    };


    // Form Parts toggling
    var toggle_form_visibility = function(){
        if(hard_copy_checked()){
            slideDown($('li.send_to_name'));
            slideDown($('li.claim_centre'));
        }else{
            slideUp($('li.send_to_name'));
            slideUp($('li.claim_centre'));
        }

        if(send_with_hard_copy_checked()){
            $('input[name=hard_copy_address]', el).val($('input[name=claim_centre]', el).val());
        }else{
            $('input[name=hard_copy_address]', el).val('');
        }

        if(send_with_electronic_checked()){
            $('input[name=send_invoice_email]', el).val($('input[name=send_to_email]', el).val());
        }else{
            $('input[name=send_invoice_email]', el).val('');
        }

        // Fill in send_to_address and send_to_email as appropriate

    }

    toggle_form_visibility();

    $('input[name=hard_copy_required]', el).click(toggle_form_visibility).change(toggle_form_visibility);
    $('input[name=send_with_electronic]', el).click(toggle_form_visibility).change(toggle_form_visibility);
    $('input[name=send_with_hard_copy]', el).click(toggle_form_visibility).change(toggle_form_visibility);

    $(el).validate({
        submitHandler: callback,
        rules: {

        audio_file: {required: true},

        claim_no: {required: true},
        interview_date: {required: true},
        interviewer_name: {required: true},
        interviewee_name: {required: true},

        send_to_email: {required: true, email: true},
        cc_to_email: {required: true, email: true},

        send_to_name: {required: hard_copy_checked},
        claim_centre: {required: hard_copy_checked}


    // Common Fields
        }
    });

};

export function enable_bcas_form(el, callback){

    // Checking functions
    var hard_copy_checked = function(){
        return !!$('form.upload_form input[name=hard_copy_required]:checked').val();
    };

    var electronic_checked = function(){
        return !!$('form.upload_form input[name=electronic_required]:checked').val();
    };

    // Form Parts toggling
    var toggle_form_visibility = function(){
        if(hard_copy_checked()){
            slideDown($('li.hard_copy_address'));
        }else{
            slideUp($('li.hard_copy_address'));
        }

        if(electronic_checked()){
            slideDown($('li.send_to_email'));
        }else{
            slideUp($('li.send_to_email'));
        }

    }

    toggle_form_visibility();

    $('input[name=electronic_required]', el).click(toggle_form_visibility).change(toggle_form_visibility);
    $('input[name=hard_copy_required]', el).click(toggle_form_visibility).change(toggle_form_visibility);

    $(el).validate({
        submitHandler: callback,
        rules: {
          // Validation rules for each field, if necessary.

          audio_file: {required: true},

          date_of_loss: {required: true},
          patient_name: {required: true},
          cliff_no: {required: true},

          send_to_email: {required: electronic_checked, email: true}
        }
    });
};

export function enable_forests_form(el, callback) {
  return enable_generic_form(el, callback);
}

export function enable_generic_form(el, callback){
    // Checking functions
    var hard_copy_checked = function(){
        return !!$('form.upload_form input[name=hard_copy_required]:checked').val();
    };

    var electronic_checked = function(){
        return !!$('form.upload_form input[name=electronic_required]:checked').val();
    };

    // Form Parts toggling
    var toggle_form_visibility = function(){
        if(hard_copy_checked()){
            slideDown($('li.hard_copy_address'));
        }else{
            slideUp($('li.hard_copy_address'));
        }

        if(electronic_checked()){
            slideDown($('li.send_to_email'));
        }else{
            slideUp($('li.send_to_email'));
        }

    }

    toggle_form_visibility();

    $('input[name=electronic_required]', el).click(toggle_form_visibility).change(toggle_form_visibility);
    $('input[name=hard_copy_required]', el).click(toggle_form_visibility).change(toggle_form_visibility);


    $(el).validate({
        submitHandler: callback,
        rules: {

          // Validation rules for each field, if necessary.
          audio_file: {required: true},

          ordering_party_name: {required: true},
          ordering_party_address: {required: true},
          ordering_party_email: {required: true, email: true},
          ordering_party_phone: {required: true},

          hard_copy_address: {required: hard_copy_checked},
          send_to_email: {required: electronic_checked, email: true}

        }
    });

};


$(function(){





    /*
    if(icbc_form.length){
        enable_icbc_form(icbc_form);
    }

    if(bcas_form.length){
        enable_bcas_form(bcas_form);
    }


    if(aws_form.length){
        enable_aws_form();
    }
    */

});



// WEBPACK FOOTER //
// ./src/script.js